import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from './auth.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class AuthGuard implements CanActivate {
  dateNow = new Date();
  constructor(
    private router: Router,
    private authService: AuthService,
    private toastrService: ToastrService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return new Promise<boolean>((resolve, reject) => {
      let token = this.authService.currentUserSubject.value.access_token;
      if (!token) {
        this.toastrService.error(
          'ليس لديك صلاحية الدخول لهذة الصفحة',
          'برجاء تسجيل الدخول'
        );
        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 1000);
        resolve(false);
      } else {
        resolve(true);
      }
    });
  }
}
